/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React, { type ReactElement } from 'react';

import {
	BitbucketIcon,
	ConfluenceIcon,
	JiraIcon,
	JiraServiceManagementIcon,
	JiraSoftwareIcon,
	JiraWorkManagementIcon,
} from '@atlaskit/logo';

import { ShortProductKey } from '../../model/site';

interface Props {
	productKey?: ShortProductKey;
	productName?: string;
	size?: 'small' | 'xsmall' | 'medium' | 'large' | 'xlarge';
	defaultIcon?: ReactElement;
}

export default function ProductIcon(props: Props): ReactElement | null {
	const { productKey, size = 'small', defaultIcon = null, productName } = props;

	const mapProductKeyToIcon: Record<string, ReactElement> = {
		[ShortProductKey.JIRA]: (
			<JiraIcon size={size} label={productName || 'Jira'} appearance="brand" />
		),
		[ShortProductKey.CONFLUENCE]: (
			<ConfluenceIcon size={size} label={productName || 'Confluence'} appearance="brand" />
		),
		[ShortProductKey.JIRA_SOFTWARE]: (
			<JiraSoftwareIcon size={size} label={productName || 'Jira'} appearance="brand" />
		),
		[ShortProductKey.JIRA_SERVICE_DESK]: (
			<JiraServiceManagementIcon size={size} label={productName || 'Jira'} appearance="brand" />
		),
		[ShortProductKey.JIRA_CORE]: (
			<JiraWorkManagementIcon size={size} label={productName || 'Jira'} appearance="brand" />
		),
		[ShortProductKey.BITBUCKET]: (
			<BitbucketIcon size={size} label={productName || 'Bitbucket'} appearance="brand" />
		),
	};

	return productKey && mapProductKeyToIcon[productKey]
		? mapProductKeyToIcon[productKey]
		: defaultIcon;
}
